__turbopack_context__.v({
  "pillsWrapper": "F_UjYG_pillsWrapper" + " " + "F_UjYG_placeholderContainer",
  "placeholderContainer": "F_UjYG_placeholderContainer",
  "titlePlaceholder": "F_UjYG_titlePlaceholder",
});
